import { useEffect } from 'react';
import { getHotkeyHandler, getHotkeyMatcher, HotkeyItemOptions } from './utilts';

export type { HotkeyItemOptions };
export { getHotkeyHandler };

export type HotkeyItem = [string, (event: KeyboardEvent) => void, HotkeyItemOptions?];

function shouldFireEvent(
  event: KeyboardEvent,
  tagsToIgnore: string[],
  triggerOnContentEditable = false,
) {
  if (event.target instanceof HTMLElement) {
    if (triggerOnContentEditable) {
      return !tagsToIgnore.includes(event.target.tagName);
    }

    return !event.target.isContentEditable && !tagsToIgnore.includes(event.target.tagName);
  }

  return true;
}
/**
 * Hook from https://mantine.dev/hooks/use-hotkeys/
 * @param hotkeys — массив пар [сочетание клавиш, callback], например: [['mod+K', () => openModal()]]
 * @param tagsToIgnore — массив тегов, внутри которых хоткеи не срабатывают (по умолчанию ['INPUT', 'TEXTAREA', 'SELECT'])
 * @param triggerOnContentEditable — срабатывать ли хоткеям внутри contentEditable (по умолчанию false)
 * @param options — дополнительные опции (например, eventType: 'keydown' | 'keyup', scope и др.)
 */
export function useHotkeys(
  hotkeys: HotkeyItem[],
  tagsToIgnore: string[] = ['INPUT', 'TEXTAREA', 'SELECT'],
  triggerOnContentEditable = false,
) {
  useEffect(() => {
    const keydownListener = (event: KeyboardEvent) => {
      hotkeys.forEach(
        ([hotkey, handler, options = { preventDefault: true, usePhysicalKeys: false }]) => {
          if (
            getHotkeyMatcher(hotkey, options.usePhysicalKeys)(event) &&
            shouldFireEvent(event, tagsToIgnore, triggerOnContentEditable)
          ) {
            if (options.preventDefault) {
              event.preventDefault();
            }

            handler(event);
          }
        },
      );
    };

    document.documentElement.addEventListener('keydown', keydownListener);
    return () => document.documentElement.removeEventListener('keydown', keydownListener);
  }, [hotkeys]);
}
